export const EMPLOYEE_PERMISSIONS = {
  INVENTORY_MANAGE: 'inventory:manage',
  CATALOG_MANAGE: 'catalog:manage',
  REPORTS_VIEW: 'reports:view',
  EMPLOYEE_PASSWORD_RESET: 'employees:password-reset'
}

export const EMPLOYEE_PERMISSION_OPTIONS = [
  {
    value: EMPLOYEE_PERMISSIONS.INVENTORY_MANAGE,
    label: 'Add and remove inventory'
  },
  {
    value: EMPLOYEE_PERMISSIONS.CATALOG_MANAGE,
    label: 'Manage items and manufacturers'
  },
  {
    value: EMPLOYEE_PERMISSIONS.REPORTS_VIEW,
    label: 'View reports and dashboard'
  },
  {
    value: EMPLOYEE_PERMISSIONS.EMPLOYEE_PASSWORD_RESET,
    label: 'Reset passwords for standard employees'
  }
]

export const hasEmployeePermission = (userInfo, ownerInfo, permission) =>
  Boolean(ownerInfo?.isOwner || userInfo?.permissions?.includes(permission))
